/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { DeleteCourseSectionOptions, DeleteCourseSectionResponses } from '../../models/DeleteCourseSection'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @summary Delete Course Section
 * {@link /admin/course/:course_id/sections/:section_id}
 */
export function deleteCourseSection<ThrowOnError extends boolean = true>(options: Options<DeleteCourseSectionOptions, ThrowOnError>): Promise<UnwrappedResult<DeleteCourseSectionResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'DELETE', url: '/admin/course/{course_id}/sections/{section_id}', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<DeleteCourseSectionResponses, ThrowOnError>>
}
